export default interface IProjectStartInfo {
  ctorProjectName: string;
  localFilePath?: string;
  localFolderPath?: string;
  accessoryFiles?: string[];
}
